import  { NavLink } from "react-router";
import { formatDate, uniqid } from "../../tools/utils";
import { RoleLevel, roleNames, roles, type rolesList, type User, type UsersParameters } from "../../types/Users";
import Pager from "../Common/Pager";
import { useLookupUsersQuery } from "../../stores/OkOkStore";
import { useState, type ChangeEvent } from "react";
import { useTrads } from "../../contexts/trads/useTrads";
import { useAuth } from "../../contexts/auth/useAuth";


function UsersList({filtre}:{filtre:UsersParameters}){
    const [params,setParams]=useState<UsersParameters>({...filtre,page:0});
    const { data, error, isLoading } = useLookupUsersQuery(params);
    const {translate}=useTrads();
    const setPage=function(page:number){
       setParams({...params,page: page})
    }
    const setOrder=function(order:string,reverse?:number){
        setParams({...params,order:order,reverse:reverse ?? 0});
    }

    const onChangeRangAcces=function(e:ChangeEvent<HTMLInputElement>){
        const z:string[]=params.r.rangacces ? [...params.r.rangacces]:[];
        if(e.target.checked){
            if(!z.includes(e.target.value)){
                z.push(e.target.value);

            }
        }else{
            const index=z.indexOf(e.target.value);
            if(index>=0){
                z.splice(index, 1);

            }
        }
        setParams(
            {...params,
                   r:{...params.r,rangacces:z}
            }
        );

    }
    const setLookup=function(lookup:string){
        const l={"fulltext":lookup}
        setParams({...params,r:{...params.r,...l}});
    }


    const {hasRole} = useAuth();


    return (
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>

            ) : data ? (
                <>
            <div>
                <fieldset className="role-filter">
                    <legend>Role</legend>

                    {Object.entries(roleNames).sort((a,b)=> RoleLevel[a[0] as rolesList] - RoleLevel[b[0] as rolesList])
                    .map(([key, value])=> {
                        const id=uniqid();
                        return (
                        <div  className="form-check form-switch"  key={key}>
                            <input id={id} className="form-check-input"  type="checkbox" value={key} onChange={onChangeRangAcces} checked={params.r.rangacces?.includes(key)} /> 
                            <label htmlFor={id} className="form-check-label">  {value}  </label>
                        </div>
                        )
                    })}
                </fieldset>
                <div>
                    <input type="text" placeholder="search" name="search" onBlur={e => { setLookup(e.target.value)} } />
                </div>


            </div>
            <Pager curpage={data.page} totalpages={data.pages} setter={setPage} />

            <table className="table">
                <thead className="sticky-top">
                    <tr>
                        <th scope="col">{translate('user_date_creation')}</th>
                        <th scope="col">{translate('user_nom')}</th>
                        <th scope="col">{translate('user_identifiant')}</th>
                        <th scope="col" data-sort="rangacces">
                            <div className="table-sort">
                                {translate('user_role')}
                                <div className={(params.order=='rangacces')?((params.reverse)?'desc':'asc'):undefined}>
                                    <a className='up' onClick={()=>{ setOrder('rangacces',1); }} ><i className="bi"></i></a>
                                    <a className='down' onClick={()=>{ setOrder('rangacces',0); }} ><i className="bi"></i></a>
                                </div>
                            </div>


                        </th>
                        {hasRole(roles.Administrators)?<th scope="col">{translate('user_validation')}</th>:null}
                        <th scope="col"></th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
            {data.data.map((profil:User) => (
                <tr key={profil.id}>
                    <td>{profil.date_creation?formatDate(profil.date_creation):null}</td>
                    <td>{profil.nom}</td>
                    <td>{profil.identifiant}</td>
                    <td>{roleNames[profil.rangacces]}</td>
                    {hasRole(roles.Administrators)?<th>{profil.validation}</th>:null}
                    <td>
                        <NavLink to={`/user/${profil.id.toString()}`}>
                            <span className="visually-hidden">{translate('btn_voir')}</span>
                            <i className="bi bi-eye-fill"></i>
                        </NavLink>
                    </td>
                    <td>
                        {hasRole(roles.Manager)?
                            <NavLink to={`/user/${profil.id.toString()}/edit`}>
                                <span className="visually-hidden">{translate('btn_edit')}</span>
                                <i className="bi bi-pencil-fill"></i>
                            </NavLink>
                        :null}
                    </td>
                </tr>
            ))}
            </tbody>
            </table>
            <Pager curpage={data.page} totalpages={data.pages} setter={setPage} />
            </>
        ) :null
    ); 
}
export default UsersList;